// extracted by mini-css-extract-plugin
export default {"htmlContent":"YbZhe7","description":"DfWNBO","content":"eCUCF_","descriptionWrapper":"Hq30ZF","title":"TM_WoT","contentWrapper":"AJC0Rz","showMoreOrLess":"jxiFxb"};